"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ListFilter = _interopRequireDefault(require("@/components/ListFilter"));
var _ManageImport = _interopRequireDefault(require("./modules/ManageImport.vue"));
var _index = _interopRequireDefault(require("@/components/SkinPreview/index.vue"));
var _fliterConfig = _interopRequireDefault(require("./fliterConfig.js"));
var _paginationEffect = _interopRequireDefault(require("@/utils/paginationEffect"));
var _api = require("./api");
var _enum = require("../../enum");
var _jsCookie = _interopRequireDefault(require("js-cookie"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'AppletSettingPageList',
  components: {
    ListFilter: _ListFilter.default,
    ManageImportVue: _ManageImport.default,
    SkinPreview: _index.default
  },
  data: function data() {
    return _objectSpread({
      listLoading: false,
      tableData: {
        list: [],
        total: 0
      },
      tableFrom: {},
      FILTER_ITEMS: [],
      userType: null
    }, (0, _paginationEffect.default)(this.handlerGetListData));
  },
  created: function created() {
    try {
      var JavaInfo = JSON.parse(_jsCookie.default.get('JavaInfo'));
      this.userType = JavaInfo.type;
    } catch (e) {
      this.userType = null;
    }
    var filterConfig = (0, _fliterConfig.default)({
      handleSearch: this.handleSearch,
      userType: this.userType
    });
    this.FILTER_ITEMS = filterConfig.FILTER_ITEMS;
    this.handlerGetListData(this.pageData);
  },
  methods: {
    formatPageType: function formatPageType(type) {
      var typeItem = _enum.pageType.find(function (item) {
        return item.value === type;
      });
      return typeItem ? typeItem.label : '未知类型';
    },
    formatPageStatus: function formatPageStatus(status) {
      var statusItem = _enum.pageStatus.find(function (item) {
        return item.value === status;
      });
      return statusItem ? statusItem.label : '未知状态';
    },
    copy: function () {
      var _copy = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(row) {
        var _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return (0, _api.copyDesignApi)({
                id: row.id
              });
            case 1:
              this.handleSearch();
              this.$message({
                type: 'success',
                message: '复制成功!'
              });
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              this.$message({
                type: 'error',
                message: '复制失败!' + _t
              });
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function copy(_x) {
        return _copy.apply(this, arguments);
      }
      return copy;
    }(),
    add: function add() {
      this.$router.push({
        path: "/applet/skinSetting",
        query: {
          type: 3
        }
      });
    },
    handleSearch: function handleSearch(data) {
      if (data) {
        this.tableFrom = _objectSpread({}, data);
      } else {
        this.tableFrom = {};
      }
      if (Number(this.userType) === 5) {
        delete this.tableFrom.customerId;
        delete this.tableFrom.appId;
      }
      this.resetPageData();
    },
    handlerGetListData: function () {
      var _handlerGetListData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var params, res, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              this.listLoading = true;
              params = _objectSpread(_objectSpread({}, this.tableFrom), this.pageData);
              _context2.p = 1;
              _context2.n = 2;
              return (0, _api.companyDesignListApi)(params);
            case 2:
              res = _context2.v;
              this.tableData = res;
              this.listLoading = false;
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t2 = _context2.v;
              this.listLoading = false;
              this.$message.error(_t2);
            case 4:
              return _context2.a(2);
          }
        }, _callee2, this, [[1, 3]]);
      }));
      function handlerGetListData() {
        return _handlerGetListData.apply(this, arguments);
      }
      return handlerGetListData;
    }(),
    goDctPage: function goDctPage() {
      var row = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.$router.push({
        path: "/applet/skinSetting?id=".concat(row === null || row === void 0 ? void 0 : row.id, "&isDraft=").concat((row === null || row === void 0 ? void 0 : row.isDraft) || 0)
      });
    },
    goDecoration: function goDecoration(row) {
      var _this = this;
      if (!row.hasDraft) {
        this.goDctPage(row);
        return;
      }
      this.$confirm('系统检测到您需要装修的页面存在装修中的版本，您是否需要继续上次的装修？', '是否使用草稿', {
        confirmButtonText: '是，继续装修',
        cancelButtonText: '不，我要重新装',
        type: 'warning',
        closeOnClickModal: false,
        showClose: true,
        distinguishCancelAndClose: true
      }).then(function (result) {
        _this.goDctPage(_objectSpread(_objectSpread({}, row), {}, {
          isDraft: 1
        }));
      }).catch(function (closeType) {
        if (closeType == 'close') return;
        _this.goDctPage(_objectSpread(_objectSpread({}, row), {}, {
          isDraft: 0
        }));
      });
      return;
    },
    manageImport: function manageImport(row) {
      var isCopy = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      this.$refs.ManageImportVueRef.open(row, isCopy);
    },
    deleteRecord: function deleteRecord(row) {
      var _this2 = this;
      this.$confirm('确定删除当前数据', '提示').then(function () {
        (0, _api.deleteApi)({
          id: row.id
        }).then(function () {
          _this2.$message.success('删除数据成功');
          _this2.handleSearch();
        });
      });
    },
    setDisable: function () {
      var _setDisable = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(row) {
        var _t3;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              _context3.n = 1;
              return (0, _api.disableApi)({
                id: row.id
              });
            case 1:
              this.$message.success('操作成功');
              this.handleSearch();
              _context3.n = 3;
              break;
            case 2:
              _context3.p = 2;
              _t3 = _context3.v;
              this.$message.error(_t3);
            case 3:
              return _context3.a(2);
          }
        }, _callee3, this, [[0, 2]]);
      }));
      function setDisable(_x2) {
        return _setDisable.apply(this, arguments);
      }
      return setDisable;
    }(),
    previewH5: function previewH5(id) {
      var _this3 = this;
      var loading = this.$loading({
        lock: true,
        text: '加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      (0, _api.getDetailApi)({
        id: id,
        isDraft: 0
      }).then(function (res) {
        loading.close();
        _this3.$refs['SkinPreviewRef'].previewSetting(res);
      }).catch(function (err) {
        loading.close();
      });
    }
  }
};